'use client';
// This component is used to handle errors thrown in server components, loaders/fetch during render, or client components that bubble without a nearer client boundary.
import { useEffect } from 'react';

const Error = ({ error, reset }: { error: Error & { digest?: string }; reset: () => void }) => {
	useEffect(() => {
		console.error(error);
	}, [error]);

	return (
		<div className="mx-auto max-w-3xl p-6 text-center">
			<h1 className="mb-2 text-2xl font-semibold">Something went wrong</h1>
			<button onClick={() => reset()} className="rounded-lg bg-black px-4 py-2 text-white">
				An error occurred please try again
			</button>
		</div>
	);
};

export default Error;
